{
  "usuaris": {
    "accessos": "Accesos",
    "senseRol": "Sin rol: no puede entrar",
    "filtreSenseRol": "Sin rol",
    "filtreModificats": "Con datos modificados",
    "notaFiltresRapids": "Los filtros rápidos se aplican a la página actual.",
    "modificatCai": "Tiene datos modificados en el CAI",
    "syncGlobal": "Sincronizar todos",
    "notaSyncGlobal": "La sincronización global respeta los datos modificados en el CAI.",
    "tots": "Todos los departamentos",
    "totsRols": "Cualquier rol",
    "totsEstats": "Cualquier estado",
    "actius": "Activos",
    "inactius": "Inactivos",
    "obreFitxa": "Abrir la ficha de {{nom}}"
  },
  "fitxa": {
    "pestanyes": {
      "perfil": "Perfil",
      "accessos": "Accesos",
      "contacte": "Contacto y dispositivos",
      "activitat": "Actividad"
    },
    "ultimSync": "Última sincronización con Entra ID: {{data}}",
    "maiSync": "Nunca sincronizado con Entra ID",
    "sincronitza": "Sincronizar con Entra ID",
    "carregant": "Cargando…"
  },
  "perfil": {
    "dades": "Datos personales",
    "camps": {
      "nom": "Nombre",
      "cognoms": "Apellidos",
      "email": "Correo",
      "upn": "Usuario corporativo",
      "carrec": "Cargo",
      "departamentId": "Departamento",
      "telefon": "Móvil para avisos",
      "idioma": "Idioma de los avisos"
    },
    "origen": {
      "entra": "De Entra ID",
      "cai": "Modificado en el CAI",
      "pendent": "Cambio sin guardar",
      "bloquejat": "Entra ID"
    },
    "bloquejatTitol": "Solo se puede cambiar en Entra ID",
    "aEntra": "En Entra ID:",
    "recupera": "Recuperar este valor",
    "senseValor": "(vacío)",
    "avisLocals_one": "Esta persona tiene <b>{{count}} dato modificado en el CAI</b>. La sincronización automática lo respeta; solo «Sincronizar con Entra ID» lo sustituye.",
    "avisLocals_other": "Esta persona tiene <b>{{count}} datos modificados en el CAI</b>. La sincronización automática los respeta; solo «Sincronizar con Entra ID» los sustituye.",
    "totesEntra": "Todos los datos coinciden con Entra ID.",
    "estat": "Estado",
    "actiu": "Activo",
    "inactiu": "Inactivo",
    "ajudaEstat": "Una persona inactiva no recibe avisos ni puede entrar. Su historial se conserva.",
    "desactiva": "Desactivar usuario",
    "reactiva": "Reactivar usuario",
    "desactivaTitol": "Desactivar «{{nom}}»",
    "reactivaTitol": "Reactivar «{{nom}}»",
    "desactivaText": "Dejará de recibir avisos y no podrá entrar en el CAI. Sus roles y el historial se conservan.",
    "reactivaText": "Volverá a recibir avisos y podrá entrar con los roles que tiene asignados.",
    "desat": "Perfil guardado.",
    "nomObligatori": "El nombre es obligatorio."
  },
  "sync": {
    "titol": "Sincronizar con Entra ID",
    "avis_one": "Se sustituirá <b>{{count}} dato modificado en el CAI</b> por el valor de Entra ID. No se puede deshacer.",
    "avis_other": "Se sustituirán <b>{{count}} datos modificados en el CAI</b> por los valores de Entra ID. No se puede deshacer.",
    "senseDiferencies": "No hay diferencias: solo se actualizará la fecha de sincronización.",
    "dada": "Dato",
    "ara": "Ahora (CAI)",
    "quedara": "Quedará (Entra ID)",
    "descartaPendents": "Los cambios sin guardar también se descartarán.",
    "noToca": "Los roles, los canales y los dispositivos no se tocan: son datos propios del CAI.",
    "substitueix_one": "Sustituir {{count}} dato y sincronizar",
    "substitueix_other": "Sustituir {{count}} datos y sincronizar",
    "sincronitza": "Sincronizar",
    "fet": "Datos sincronizados con Entra ID.",
    "carregant": "Comparando con Entra ID…"
  },
  "accessos": {
    "ajuda": "Cada tarjeta es un rol. Las etiquetas indican <b>dónde</b> lo tiene; elegir un área incluye todos sus servicios.",
    "quePotFer": "Qué puede hacer ›",
    "treuRol": "Quitar rol",
    "treuRolTitol": "Quitar «{{rol}}»",
    "treuRolText": "{{nom}} dejará de ser {{rol}} en: {{on}}.",
    "enCapLloc": "ningún sitio",
    "totaOrganitzacio": "Toda la organización",
    "donaGlobal": "o darle el rol en toda la organización",
    "limita": "Limitar a una parte",
    "afegeixAmbit": "Añadir departamento, área o servicio…",
    "afegeixAmbitA": "Añadir dónde aplica el rol {{rol}}",
    "treuAmbit": "Quitar {{nom}}",
    "encaraEnlloc": "Aún no aplica en ningún sitio: añade dónde lo tiene.",
    "afegeixRol": "＋ Añadir otro rol…",
    "senseRols": "No tiene ningún rol: no puede entrar en el CAI.",
    "nouRol": "Rol nuevo: elige dónde aplica"
  },
  "rols": {
    "persones_one": "{{count}} persona",
    "persones_other": "{{count}} personas",
    "pestanyes": {
      "permisos": "Permisos",
      "persones": "Personas con este rol",
      "dades": "Datos del rol"
    },
    "queGestiona": "Qué puede gestionar",
    "cols": {
      "CONSULTAR": "Ver",
      "ALTA": "Crear",
      "MODIFICAR": "Modificar",
      "ELIMINAR": "Eliminar"
    },
    "noAplica": "No aplica",
    "grupN": "{{n}} de {{total}}",
    "marcaGrup": "Marcar todos los permisos de {{grup}}",
    "sistemaAvis": "Rol del sistema: está protegido para que nadie se quede sin acceso. Duplícalo para crear una variante.",
    "duplica": "Duplicar",
    "nou": "Nuevo rol",
    "elimina": "Eliminar",
    "eliminaTitol": "Eliminar el rol «{{rol}}»",
    "eliminaText": "Las personas que lo tienen lo perderán. No se puede deshacer.",
    "duplicaTitol": "Duplicar «{{rol}}»",
    "copiaDe": "Copia de {{nom}}",
    "duplicaAjuda": "El rol nuevo tendrá los mismos permisos. No se asigna a nadie.",
    "creaRol": "Crear el rol",
    "nouAjuda": "Se crea sin permisos; después márcalos en la matriz.",
    "codiAjuda": "Identificador corto y único, en mayúsculas. No se podrá cambiar.",
    "sensePersones": "Nadie tiene este rol.",
    "veure": "Abrir la ficha",
    "dadesDesades": "Datos del rol guardados.",
    "permisosDesats": "Permisos guardados."
  }
}
